export const LOCAL_STORAGE_KEY = '@gddashboard:';

export function startingPrice(complement_categories, isDelivery) {
  const requiredCategories = complement_categories.filter(
    (cat) => !cat.optional
  );

  const value = requiredCategories.reduce((acc, cat) => {
    const minimum = cat.minimum || 1;

    // Pega os complementos disponíveis ordenados por preço (mais barato primeiro)
    const availableComplements = cat.complements
      .filter((comp) => comp.available)
      .map((comp) => ({
        price: parseFloat(isDelivery ? comp.delivery_price || comp.price : comp.price),
        limit: comp.limit || Infinity
      }))
      .sort((a, b) => a.price - b.price);

    // Se não há complementos disponíveis, retorna 0
    if (availableComplements.length === 0) {
      return acc;
    }

    // Calcula a soma mínima possível respeitando os limits
    let remaining = minimum;
    let totalSum = 0;
    let maxPrice = 0;

    for (const comp of availableComplements) {
      if (remaining <= 0) break;
      const qty = Math.min(remaining, comp.limit);
      totalSum += comp.price * qty;
      if (qty > 0) {
        maxPrice = comp.price;
      }
      remaining -= qty;
    }

    // Se cobra apenas o mais caro
    if (cat.more_expensive_only) {
      return acc + maxPrice;
    }

    // Se cobra a média
    if (cat.use_average) {
      return acc + (totalSum / minimum);
    }

    // Caso padrão: soma todos
    return acc + totalSum;
  }, 0);

  return value;
}

export const clampValue = (value, min, max) => {
  return Math.max(min, Math.min(value, max));
};
